module.exports = __webpack_public_path__ + "static/media/geoLocation.08f773bc.svg";